<template>
  <v-container>
    <p>New customer supply</p>
    <v-row>
      <v-col
        cols="12"
        lg="10"
        md="12"
      >
        <v-row>
          <v-autocomplete
            v-model="biz_customer_name"
            :items="items"
            :search-input.sync="search"
            cache-items
            class="mx-4"
            flat
            hide-no-data
            hide-details
            label="Customer/Company name"
            solo-inverted
            dense
          ></v-autocomplete>
          <v-col
            cols="12"
          ></v-col>
          <v-col
            cols="12"
            md="6"
          >
            <v-text-field
              v-model="customer_supply.maid_quantity"
              label="Maid quantity"
              type="number"
              outlined
              dense
            />
          </v-col>
          <v-col
            cols="12"
            md="6"
          >
            <v-text-field
              v-model="customer_supply.maid_salary"
              label="Maid total salary"
              type="number"
              outlined
              dense
            />
          </v-col>
        </v-row>
        <app-customer-supply-detail
          :customer_supply_detail_list="customer_supply_detail_list"
        />
        <v-divider></v-divider>
        <div class="text-left">
          <v-btn
            class="mx-2"
            small
            color="orange"
            dark
            @click="createCustomerSupply"
          >
            Create
          </v-btn>
          <v-btn
            class="mx-2"
            small
            exact
            :to="{ name: 'customer-supply-list' }"
          >
            Cancel
          </v-btn>
        </div>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import { authHeader } from '../../../_helpers';
export default {
  name: "CustomerSupplyCreate",
  components: {
    AppCustomerSupplyDetail: () => import('../components/customer-supply-detail')
  },
  data: () => ({
    biz_customer_name: null,
    customer_supply: {
      biz_customer_name: null,
      maid_quantity: null,
      maid_salary: null,
      total_cost: null,
      total_price: null,
      total: null,
      biz_customer_id: null,
    },
    search: null,
    customer_supply_detail_list: [],
    items: [],
    loading: false,
    rules: {
      require: value => !!value || 'Please fill in information',
    },
  }),
  watch: {
    search (val) {
      val && val !== this.biz_customer_name && this.searchBizCustomer(val)
    },
    biz_customer_name: {
      handler () {
        this.customer_supply.biz_customer_name = this.biz_customer_name
        let found = this.items.find(element => element.text == this.biz_customer_name)
        this.customer_supply.biz_customer_id = found.value
      }
    }
  },
  methods: {
    async createCustomerSupply () {
      try {
        if (this.requireField()) {
          console.log(this.customer_supply)
          // this.$router.push({ name: 'customer-supply-list'})
        }
      } catch (err) {
        console.log(err)
        alert('Something went wrong')
      }
    },
    requireField () {
      if (!this.customer_supply.biz_customer_id || !this.customer_supply.biz_customer_name) {
        alert('Please select customer')
        return false;
      }
      if (!this.customer_supply.maid_salary) {
        alert('Please fill in maid salary')
        return false;
      }
      return true
    },
    searchBizCustomer (val) {
      this.loading = true
      this.$http.get(`/back-office/biz-customers?keyword=${val}`, authHeader()).then(result => {
        let { data } = result
        let items = []
        for (let item of data) {
          items.push({
            text: item.company_name,
            value: item.id
          })
        }
        // console.log('ya?')
        this.items = items.filter(e => {
          return (e.text || '').toLowerCase().indexOf((val || '').toLowerCase()) > -1
        })
        this.loading = false
      })
    },
  },
};
</script>
